import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from 'react';
import Home from "./components/Home/Home";
import { useDispatch } from "react-redux";
import Login from './components/Login/Login';
import { setSecurityKey } from "./features/tableData/visualSlice";

function App() {
  const dispatch = useDispatch();
  function handleLogin(skey) {
      dispatch(setSecurityKey(skey));
  }
  return (
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login callback={handleLogin}/>} />
          <Route path="/Home" element={<Home/>} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>

  );
}

export default App;
